<template>
  <v-container v-if="!loading && Contracts && Contracts.length > 0"
               class="pa-0"
               fluid>
    <HoverMenu v-for="contract in Contracts"
               :key="contract.Id"
               :nudgeamount="-3">
      <template v-slot:menu-activator>
        <normal-mode-template :label="$t('servicesystem.common_objects.machine.contracted_to')"
                              class="ml-2">
          <template v-slot:value>
            <a :href="contractpageurl(contract.ContractId, contract.Id)"
               class="ml-3 mb-2 text-decoration-none"
               :class="textcolor(contract)+ '--text'">
              {{contract.ContractId}} {{contract.Name}}
            </a>
          </template>
        </normal-mode-template>
      </template>

      <template v-slot:menu-content>
        <v-progress-circular v-if="loading"
                             indeterminate
                             color="primary">
        </v-progress-circular>
        <div v-else-if="!loading && Contracts">
          <v-container class="pa-0"
                       fluid>
            <v-row no-gutters>
              <v-col cols="6">
                <date-li :label="$t('servicesystem.common_objects.commonterms.start')"
                         :value="contract.ContractStart">
                </date-li>
              </v-col>
              <v-col cols="6">
                <date-li :label="$t('servicesystem.common_objects.commonterms.end')"
                         :value="contract.ContractEnd">
                </date-li>
              </v-col>
            </v-row>
            <v-row no-gutters
                   v-if="contract.ContractTerminated">
              <v-col>
                <date-li :label="$t('servicesystem.common_objects.commonterms.terminated')"
                         :value="contract.ContractTerminated"
                         :valuecolor="textcolor(contract)">
                </date-li>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </template>
    </HoverMenu>
  </v-container>

  <normal-mode-template v-else-if="!loading"
                        :label="$t('servicesystem.common_objects.machine.contracted_to')"
                        class="ml-2">
    <template v-slot:value>
      <div class="ml-3 mb-2 mt-1 valuetext"
           v-text="$t('servicesystem.common_objects.fallbackterms.no_machine_contract')" />
    </template>
  </normal-mode-template>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import DateLi from "@/components/Inputs/DateListItem.vue";
import NormalModeTemplate from "@/components/Inputs/Parts/NormalModeTemplate.vue";
import HoverMenu from "@/components/Menus/HoverMenu.vue";

export default {
  name: "MachineContractHoverCard",
  props: ["id"],
  components: {
    DateLi,
    NormalModeTemplate,
    HoverMenu,
  },
  mixins: [clientAPI],

  data() {
    return {
      Contracts: null,
      loading: false,
    };
  },

  mounted() {
    this.get();
  },

  methods: {
    async get() {
      this.Contracts = await this.getContracts(this.id, this.loading);
      
    },

    async getContracts(machineId, loadingvar) {
      loadingvar = true;
      var result = await this.getMachineContractsById(machineId)
        .then((response) => {
          return response;
        })
        .catch((exception) => {
          console.error(exception);
          return null;
        })
        .finally(() => (loadingvar = false));
      this.loading = loadingvar;
      return result;
    },

    contractpageurl(contractid, contractdetailid) {
      return (
        window.location.origin +
        "/ServiceProviderWebSite/Views/Contracts/ManageContractEdit.aspx?contractId=" +
        contractid +
        "&contractDetailId=" +
        contractdetailid
      );
    },

    textcolor(contract) {
      var color = "disabled";
      if (contract.ContractActive) {
        if (!contract.ContractValid) {
          color = "error";
        } else {
          if (contract.ContractTerminated) {
            
            if (this.comparedatetime(contract.ContractTerminated, this.getToday())) {
              color = "tertiary"; //if termination set but is in the future
            }
          } else {
            if (this.comparedatetime(contract.ContractEnd, this.getToday())) {
              color = "primary"; //if not ended yet
            }
          }
        }
      }
      return color;
    },
  },

  computed: {},

  watch: {
    id: function () {
      this.get();
    },
  },
};
</script>

<style lang="scss">
</style>